/* src/app/shared-components/page-title/page-title.component.scss */
.page-title {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #ffffff optional;
  z-index: 3;
}
.page-title .name {
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 300;
  font-family: EYInterstate;
  color: #2e2e38;
  margin-bottom: 0.5rem;
}
.page-title .updated {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  font-family: EYInterstate;
  color: #72727f;
  margin-bottom: 0;
}
/*# sourceMappingURL=page-title.component.css.map */
